import { FC } from "react";

export type MainContainerProps = {
  full?: boolean;
  children?: React.ReactNode;
};

export const MainContainer: FC<MainContainerProps> = ({ children, full }) => {
  return (
    <div
      className={`bg-gray-25 mt-14 ${
        full ? "max-w-full" : "max-w-7xl mx-auto"
      }`}
    >
      {children}
    </div>
  );
};
